export const environment = {
  production: true,
  backendUrl: 'https://tylo-api.gung.io/',
  projectName: 'tylo',
  siteTitle: 'Tylö Pro Shop',
  mainCountry: 'se',
  copyToCartExcludedProductIds: ['00000023'],
  logoName: 'tylo-logo.png'
};
